import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-filter-radio-group',
  templateUrl: './filter-radio-group.component.html',
  styleUrls: ['./filter-radio-group.component.scss']
})
export class FilterRadioGroupComponent implements OnInit {
  @Input() name: string;

  constructor() { }

  ngOnInit(): void {
  }

}
